import RestApi from '@utilities/RestApi'
import Axios from 'axios'

import ConsultationsAuthApiClient from '@modules/auth/auth.api'
import { refreshTokenInterceptor } from '@services/APIInterceptors/refreshTokenInterceptors'

class MarketingSingleton {
  constructor() {
    const httpConfig = {
      baseURL: import.meta.env.VITE_REACT_APP_URL_MARKETING,
      headers: {
        'Content-Type': 'application/json',
      },
    }

    this.client = Axios.create(httpConfig)
    console.info(`Axios instance MARKETING: ${this.client.defaults.baseURL}`)

    this.client.interceptors.request.use(refreshTokenInterceptor)

    // PROFESIONAL CALLS
    this.auth = new ConsultationsAuthApiClient(this.client)

    //ADMIN CALLS
    this.MContent = new RestApi(this.client, '/api/contents', { linkSubstitutions: 'false' })
    this.MFeed = new RestApi(this.client, '/api/feeds')
    this.MUserGroups = new RestApi(this.client, '/api/usergroups')
    this.MrelationshipsFeed = new RestApi(this.client, '/api/feedrelationships/feed')
    this.MrelationshipsGroup = new RestApi(this.client, '/api/feedrelationships/usergroup')
    this.Mrelationships = new RestApi(this.client, '/api/feedrelationships')
  }

  static get instance() {
    return this._instance || (this._instance = new this())
  }

  updateHeaders(headerLines) {
    this.client.defaults.headers.common = {
      ...this.client.defaults.headers.common,
      ...headerLines,
    }
  }

  // sets the default headers
  removeHeaders() {
    this.client.defaults.headers.common = {
      Accept: 'application/json',
    }
  }
}

const Marketing = MarketingSingleton.instance
export default Marketing
